// リプレイの画面写真(2026-11-02 将来構想「名場面の共有」)。試合の後のリプレイで「写真」を押すと、
// いま映っている画面(3D の絵 + ダメージの数字などの2D の重ね描き)に、下の帯(ゲーム名・面・前進の秒・アドレス)を足した JPEG を作り、
// スマホは共有の画面(写真に保存・SNS へ)、共有できないブラウザ(PC など)はダウンロードにする。
// 絵を作る所(composeSnapshot)はブラウザの canvas を使う。名前と帯の文(snapshotName・stampLines)は node のテストで確かめる。

export const SNAPSHOT = { quality: 0.9, maxWidth: 1600, band: 0.075 }; // band: 下の帯の高さ(画像の高さに対する割合)

// ファイルの名前: senseofdopa-stage3-2m05s.jpg
export function snapshotName(stage, progress) {
  const s = Math.max(0, Math.floor(progress));
  return `senseofdopa-stage${stage}-${Math.floor(s / 60)}m${String(s % 60).padStart(2, "0")}s.jpg`;
}

// 下の帯の文: 左にゲーム名、右に「STAGE n ・ m:ss」とアドレス
export function stampLines({ stage, progress, url }) {
  const s = Math.max(0, Math.floor(progress));
  return { left: "SENSEOFDOPA", right: `STAGE ${stage} · ${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`, url: url.replace(/^https?:\/\//, "").replace(/\/$/, "") };
}

// layers: 重ねる canvas(下から順。3D の絵 → 2D の重ね描き)。どれも同じ画面の大きさで描かれている前提
export function composeSnapshot(layers, info, doc = document) {
  // いちばん細かい層(ふつうは2D の重ね描き。3D は描画の細かさの自動調整で粗いことがある)の大きさに合わせる
  const base = layers.filter((c) => c && c.width).reduce((a, c) => (c.width > a.width ? c : a));
  const scale = Math.min(1, SNAPSHOT.maxWidth / base.width);
  const w = Math.round(base.width * scale);
  const h = Math.round(base.height * scale);
  const band = Math.round(h * SNAPSHOT.band);
  const out = doc.createElement("canvas");
  out.width = w;
  out.height = h + band;
  const ctx = out.getContext("2d");
  ctx.fillStyle = "#060a18";
  ctx.fillRect(0, 0, out.width, out.height);
  for (const c of layers) if (c && c.width && c.height) ctx.drawImage(c, 0, 0, w, h);
  // 下の帯
  const lines = stampLines(info);
  const pad = Math.round(band * 0.35);
  ctx.fillStyle = "rgba(6, 10, 24, 0.96)";
  ctx.fillRect(0, h, w, band);
  ctx.fillStyle = "#ff7ad9";
  ctx.fillRect(0, h, w, Math.max(1, Math.round(band * 0.04)));
  ctx.textBaseline = "middle";
  const mid = h + band / 2;
  ctx.font = `700 ${Math.round(band * 0.42)}px Oxanium, sans-serif`;
  ctx.fillStyle = "#e6ecff";
  ctx.textAlign = "left";
  ctx.fillText(lines.left, pad, mid);
  ctx.textAlign = "right";
  ctx.font = `600 ${Math.round(band * 0.3)}px Oxanium, sans-serif`;
  ctx.fillStyle = "#7fd0ff";
  ctx.fillText(lines.right, w - pad, mid - band * 0.17);
  ctx.fillStyle = "#8a93b0";
  ctx.font = `400 ${Math.round(band * 0.24)}px Oxanium, sans-serif`;
  ctx.fillText(lines.url, w - pad, mid + band * 0.2);
  return out;
}

// 共有できれば共有、できなければダウンロード。返り値: "shared" | "saved" | "cancelled"
export async function deliverSnapshot(canvas, { name, text, url }) {
  const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", SNAPSHOT.quality));
  if (!blob) throw new Error("画像を作れませんでした");
  const file = typeof File === "function" ? new File([blob], name, { type: "image/jpeg" }) : null;
  if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], text, url });
      return "shared";
    } catch (e) {
      if (e && e.name === "AbortError") return "cancelled"; // 共有の画面を閉じた
      // それ以外(許可されない等)はダウンロードへ
    }
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 10000);
  return "saved";
}
